import { AdminService } from 'src/app/services/admin/admin.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class AdminGuard implements CanActivate {
  constructor(
    private AdminService: AdminService,
    private Router: Router
    )
  {

  }

canActivate(route: ActivatedRouteSnapshot, state?: RouterStateSnapshot): boolean | UrlTree {
  // 1) ავტორიზაცია
  const logged = this.AdminService.isLogged();
  if (!logged) {
    return this.Router.parseUrl('/login');
  }

  const requiredPermission = route.data?.['permission'];

  // Debug (დროებით)
  const role = this.AdminService.role();
  const permissionsRaw: string[] = this.AdminService.getPermissions?.() || [];
  const permissions = permissionsRaw.map(p => String(p).toLowerCase());
  const req = requiredPermission ? String(requiredPermission).toLowerCase() : '';

  // console.log('[AdminGuard] route', {
  //   url: state?.url,
  //   requiredPermission,
  //   role,
  //   permissionsCount: permissions.length,
  //   permissions: permissionsRaw,
  // });

  // 2) თუ permission არ არის მითითებული → ყველასთვის დაშვებული
  if (!requiredPermission) {
    return true;
  }

  // 3) super admin ყველაფერს ხედავს
  if (role === 'admin') {
    return true;
  }

  // 4) თუ manager-ს permissions საერთოდ არ აქვს ჩატვირთული (ხშირად ხდება როცა მხოლოდ JWT payload ინახება)
  // ამ შემთხვევაში არ გადავაგდოთ /not-found-ზე; დავუშვათ ნავიგაცია და backend მაინც გააკონტროლებს.
  // (სჯობს აპის სტარტზე /admin/me გამოიძახო და permissions ლოკალურად შეინახო)
  if (!permissions.length) {
    // console.warn('[AdminGuard] permissions empty; allowing navigation (call /admin/me on app init).', {
    //   requiredPermission,
    //   role,
    // });
    return true;
  }

  // 5) Permission mapping
  // route-ში შეიძლება იყოს "menu" მაგრამ backend აბრუნებს "menus_view" ტიპს.
  // აქ ვქმნით ყველა შესაძლო ვერსიას.
  const candidates = Array.from(
    new Set([
      req,
      `${req}_view`,
      `${req}_create`,
      `${req}_edit`,
      `${req}_delete`,

      // Singular -> plural (menu -> menus)
      `${req}s_view`,
      `${req}s_create`,
      `${req}s_edit`,
      `${req}s_delete`,

      // თუ route-ში უკვე plural-ითაა (menus) — singular fallback
      req.endsWith('s') ? req.slice(0, -1) + '_view' : '',
      req.endsWith('s') ? req.slice(0, -1) + '_create' : '',
      req.endsWith('s') ? req.slice(0, -1) + '_edit' : '',
      req.endsWith('s') ? req.slice(0, -1) + '_delete' : '',
    ].filter(Boolean))
  );

  const allowed = candidates.some(p => permissions.includes(p));

  // console.log('[AdminGuard] permission check', {
  //   requiredPermission: req,
  //   candidates,
  //   allowed,
  // });

  if (allowed) {
    return true;
  }

  return this.Router.parseUrl('/not-found');
}
}
